<script>
import {useRoute} from "vue-router";
import {ref, watch, defineComponent} from "vue";
import {GET_TOUR_RANK_BY_TOUR_CATEGORIES} from "@/graphql/operations/tournament-rank.ts";
import {useQuery} from "@vue/apollo-composable";

export default defineComponent({
  props: {
    categories: Array,
  },

  data(props) {
    const dataRank = ref([]);
    const route = useRoute();
    const params = route.params.name;
    const tournamentName = params[0];

    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
      showSizeChanger: true,
    });

    console.log(props.categories);

    const arrDocumentId = props.categories.map((item) => item.documentId);

    const {result: resultTournamentRank} = useQuery(GET_TOUR_RANK_BY_TOUR_CATEGORIES, () => ({
      documentIds: arrDocumentId,
      page: parseInt(pagination.value.current),
      pageSize: parseInt(pagination.value.pageSize),
    }));

    watch(
        resultTournamentRank?.value?.tournamentRanks_connection?.nodes,
        (tournamentRank) => {
          if (tournamentRank) {
            const hasCategories = arrDocumentId.length > 0;
            if (tournamentRank && hasCategories) {
              dataRank.value = tournamentRank;
            } else {
              dataRank.value = [];
            }
          }
        },
        {deep: true}
    );

    return {
      dataRank,
      pagination,
      tournamentName
    }
  },
});
</script>

<template>
  <div class="table-responsive table-datatble">
    <table class="table table-borderless dashboard-card-table">
      <thead class="thead-light">
      <tr>
        <th>Xếp hạng</th>
        <th>Vận động viên</th>
        <th>Hạng mục</th>
        <th>Điểm</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in dataRank" :key="item.id">
        <td>
          {{ index + 1 }}
        </td>
        <td>
          <h5>
            {{
              `${item?.player?.first_name} ${
                  item?.player?.middle_name ?? ""
              } ${item?.player?.last_name}`
            }}
          </h5>
        </td>
        <td>
          <h6>{{ item?.round?.category?.name }}</h6>
        </td>
        <td>
          <h4>{{ item?.point }}</h4>
        </td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>

</style>